import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from "react-router-dom";
import {
    IonSegment, IonSegmentButton, IonCardTitle, IonLabel, IonCard, IonCardHeader, IonCardContent, IonIcon,
    IonButtons, IonContent, IonHeader, IonMenu, IonBackButton, IonPage, IonTitle, IonToolbar, IonGrid, IonRow, IonCol, IonButton, IonText,
    IonPopover,
    IonDatetime,
    IonList,
    IonItem
} from '@ionic/react';
import { cashOutline, funnel } from 'ionicons/icons';
import './Home.css';
import Select from 'react-select'
import UtilActions from '../../../actions/UtilActions';
import { getLoginApp } from '../../../utils/functions';
import PosActions from '../../../actions/PosActions';
import {
    queryAllPermisions
} from "../../../data_base_local/dataservice";
import { baseurl } from '../../../constants/constants';
import { Capacitor } from '@capacitor/core';
import moment from 'moment';
import Moment from 'react-moment';
const options2 = { style: 'currency', currency: 'USD' };
const _numberFormat = new Intl.NumberFormat('en-US', options2);

interface IProps {
    post_: any;
    get_: any;
}

interface IState {
    data_default: any;
    segmentActive: any;
    cash_register_util: any;
    fields_register: any;
    array_cash_denominations: any;
    array_cash_secondary: any;
    formErrors: any;
    datalogin: any;
    period: any;
    minirepoort: any;
    currencyprimary: any;

    isOpenTransactionDate: any;
    isOpenDateStart: any;
    isOpenDateEnd: any;
    DateStart: any;
    DateEnd: any;
    isOpenModalFilterDate: any;
}
class Home extends React.Component<IProps, IState> {
    constructor(props: any) {
        super(props)
        this.state = {
            data_default: props.data_default,
            segmentActive: props.segmentActive,
            cash_register_util: props.cash_register_util,
            fields_register: {
                'id': null,
                'user_id': null,
                'location_id': null,
                'denominations': null,
                'denominations_secondary': null,
                'tasa_cambio': 0,
                'open_amount_secondary': 0,
                'open_amount': 0
            },
            array_cash_denominations: [],
            array_cash_secondary: [],
            formErrors: [],
            datalogin: props.datalogin,
            period: props.period,
            minirepoort: props.minirepoort,
            currencyprimary: props.currencyprimary,

            isOpenTransactionDate: false,
            isOpenDateStart: false,
            isOpenDateEnd: false,
            DateStart: moment(new Date(), "YYYY-MM-DD hh:mm").format("YYYY-MM-DD"),
            DateEnd: moment(new Date(), "YYYY-MM-DD hh:mm").format("YYYY-MM-DD"),
            isOpenModalFilterDate: false,
        };
    }

    async componentDidMount() {
        this.setState({
            segmentActive: 1,
            datalogin: getLoginApp(),
            period: 'day',

            isOpenDateStart: false,
            isOpenDateEnd: false,
            DateStart: moment(new Date(), "YYYY-MM-DD hh:mm").format("YYYY-MM-DD"),
            DateEnd: moment(new Date(), "YYYY-MM-DD hh:mm").format("YYYY-MM-DD"),
            isOpenModalFilterDate: false
        });
        if (Capacitor.isNativePlatform()) {
            this.ValidatePermission();
        }

        setTimeout(this.refreshminireport.bind(this), 100);

    }

    /*necesario para validar permisos*/
    async ValidatePermission() {

        let dataPermissions: any = await queryAllPermisions().then();
        let is_valid = true;
        if (dataPermissions && dataPermissions.values.length > 0) {
            dataPermissions.values.map((val: any, key: any) => {
                if (val.status !== 'active') {
                    is_valid = false;
                }
            });
        } else {
            is_valid = false;
        }

        if (!is_valid) {
            window.location.href = baseurl() + "/home";
        }
    };
    /* fin necesario para validar permisos*/

    UNSAFE_componentWillReceiveProps(nextProps: any) {
        this.setState({
            currencyprimary: nextProps.data.data_default && nextProps.data.data_default.cash_register_util ? nextProps.data.data_default.cash_register_util.currencyprimary : '',

            data_default: nextProps.data.data_default,
            cash_register_util: nextProps.data.data_default && nextProps.data.data_default.cash_register_util ? nextProps.data.data_default.cash_register_util : null,
            array_cash_denominations: (nextProps.data.data_default &&
                nextProps.data.data_default.cash_register_util &&
                nextProps.data.data_default.cash_register_util.array_cash_denominations &&
                nextProps.data.data_default.cash_register_util.array_cash_denominations) ?? [],
            array_cash_secondary: (nextProps.data.data_default &&
                nextProps.data.data_default.cash_register_util &&
                nextProps.data.data_default.cash_register_util.array_cash_secondary &&
                nextProps.data.data_default.cash_register_util.array_cash_secondary) ?? [],
            minirepoort: nextProps.data.minirepoort ? nextProps.data.minirepoort : {
                total_pre_sales: 0,
                total_quotations: 1,
                total_sales: 0,
                total_suspended: 0,
                total_transactions: 0
            }
        });

    }

    handleChangeRegister(event: any) {
        let fields_register = this.state.fields_register;
        fields_register[event.target.name] = event.target.value;

        this.setState({
            fields_register: fields_register,
        });
    }

    handleChangeArrayDenomitations(index: any, e: any) {
        let array_cash_denominations = this.state.array_cash_denominations;
        let array_cash_secondary = this.state.array_cash_secondary;

        if (e.target.type == 'cash') {
            const newArr = array_cash_denominations.map((item: any, i: any) => {
                if ((index) == i) {
                    return {
                        ...item,
                        ['quantity']: e.target.value,
                    };
                } else {
                    return item;
                }
            });
            this.setState({
                array_cash_denominations: newArr
            });
        } else {
            const newArr = array_cash_secondary.map((item: any, i: any) => {
                if ((index) == i) {
                    return {
                        ...item,
                        ['quantity']: e.target.value,
                    };
                } else {
                    return item;
                }
            });
            this.setState({
                array_cash_secondary: newArr
            });
        }
        setTimeout(this.total_denominations.bind(this), 100);

    }

    total_denominations() {

        let array_cash_denominations = this.state.array_cash_denominations;
        let array_cash_secondary = this.state.array_cash_secondary;
        let fields_register = this.state.fields_register;

        let open_amount = 0;
        let open_amount_secondary = 0;

        array_cash_denominations.map((item: any, i: any) => {
            open_amount = open_amount + (parseFloat(item.quantity) * parseFloat(item.key));
        });
        array_cash_secondary.map((item: any, i: any) => {
            open_amount_secondary = open_amount_secondary + (parseFloat(item.quantity) * parseFloat(item.key));
        });

        fields_register['open_amount_secondary'] = open_amount_secondary;
        fields_register['open_amount'] = open_amount;

        this.setState({
            fields_register: fields_register
        });
    }

    handleFocus(event: any) {
        event.target.select();
    }

    SaveRegister() {
        let fields_register = this.state.fields_register;
        let cash_register_util = this.state.cash_register_util;
        let current_register = (cash_register_util && cash_register_util.current_register && cash_register_util.current_register.id) ?? null;

        let error = false;
        let formErrors: any = {};
        if (this.state.fields_register && !this.state.fields_register.location_id) { formErrors['location_id'] = "*Campo Requerido"; error = true };
        if (this.state.fields_register && this.state.fields_register.tasa_cambio == "") { formErrors['tasa_cambio'] = "*Campo Requerido"; error = true };

        if (!current_register && error) {
            this.setState({
                formErrors: formErrors
            });
        } else {

            fields_register['denominations'] = this.state.array_cash_denominations;
            fields_register['denominations_secondary'] = this.state.array_cash_secondary;
            fields_register['id'] = (cash_register_util && cash_register_util.current_register && cash_register_util.current_register.id) ?? null;

            if (cash_register_util && cash_register_util.current_register && cash_register_util.current_register.id) {
                this.props.post_({
                    user_id: this.state.datalogin.id,
                    typeOption: 'closeDataRegister',
                    action: 'update',
                    fields_register: this.state.fields_register
                }, "api/closeDataRegister");
            } else {
                this.props.post_({
                    user_id: this.state.datalogin.id,
                    typeOption: 'saveDataRegister',
                    action: 'create',
                    fields_register: this.state.fields_register
                }, "api/saveDataRegister");
            }
        }
    }

    changeperiod(period: any) {
        this.setState({
            period: period,
        });
        setTimeout(this.refreshminireport.bind(this), 100);
    }

    refreshminireport() {

        this.props.get_({
            typeOption: 'getSalesReport',
            period: this.state.period,
            start_date: this.state.DateStart,
            end_date: this.state.DateEnd,
            user_id: this.state.datalogin.id
        }, "api/getSalesReport");
    }

    card_redirect(view: any) {
        console.log(baseurl());
        //window.location.href = baseurl() + 'dashboard_pos/orders';
    }

    changeFilterDate(e: any) {

        let DateStart: any = null;
        let DateEnd: any = null;

        if (e.target.value == 'hoy') {
            DateStart = moment(new Date(), "YYYY-MM-DD hh:mm").format("YYYY-MM-DD");
            DateEnd = moment(new Date(), "YYYY-MM-DD hh:mm").format("YYYY-MM-DD");
        } else if (e.target.value == 'ayer') {
            DateStart = moment(new Date(), "YYYY-MM-DD hh:mm").subtract(1, 'd').format("YYYY-MM-DD");
            DateEnd = moment(new Date(), "YYYY-MM-DD hh:mm").subtract(1, 'd').format("YYYY-MM-DD");
        } else if (e.target.value == 'ultimo_7') {
            DateStart = moment(new Date(), "YYYY-MM-DD hh:mm").subtract(6, 'd').format("YYYY-MM-DD");
            DateEnd = moment(new Date(), "YYYY-MM-DD hh:mm").format("YYYY-MM-DD");
        } else if (e.target.value == 'este_mes') {
            DateStart = moment(new Date(), "YYYY-MM-DD hh:mm").startOf('month').format("YYYY-MM-DD");
            DateEnd = moment(new Date(), "YYYY-MM-DD hh:mm").endOf('month').format("YYYY-MM-DD");
        } else if (e.target.value == 'este_ano') {
            DateStart = moment(new Date(), "YYYY-MM-DD hh:mm").startOf('year').format("YYYY-MM-DD");
            DateEnd = moment(new Date(), "YYYY-MM-DD hh:mm").endOf('year').format("YYYY-MM-DD");
        } else if (e.target.value == 'ano_pasado') {
            DateStart = moment(moment().year() - 1, "YYYY-MM-DD hh:mm").startOf('year').format("YYYY-MM-DD");
            DateEnd = moment(moment().year() - 1, "YYYY-MM-DD hh:mm").endOf('year').format("YYYY-MM-DD");
        }

        this.setState({
            isOpenDateStart: false,
            DateStart: DateStart,
            isOpenDateEnd: false,
            DateEnd: DateEnd,
            isOpenModalFilterDate: false
        });

        setTimeout(this.refreshminireport.bind(this), 100);
    }
    render() {
        const { isOpenModalFilterDate, isOpenDateEnd, isOpenDateStart, DateStart, DateEnd, period, segmentActive, data_default, cash_register_util, fields_register, array_cash_secondary, array_cash_denominations, formErrors, minirepoort, currencyprimary } = this.state;
        return (
            <IonPage>
                <IonHeader>
                    <IonToolbar color="primary">
                        <IonButtons slot="start">
                            <IonBackButton defaultHref="/home" text={""} />
                        </IonButtons>
                        <IonTitle>Inicio</IonTitle>
                    </IonToolbar>
                </IonHeader>
                <IonContent fullscreen scrollEvents={true}>
                    <IonRow>
                        <IonCol col-12 size='12' class='div_horizontal_buttom_segment_pos_home'>
                            <IonSegment value={segmentActive}>
                                <IonSegmentButton
                                    value={1}
                                    onClick={() => {
                                        this.setState({
                                            segmentActive: 1
                                        });
                                    }}
                                >
                                    <IonLabel>Dashboard</IonLabel>
                                </IonSegmentButton>
                                <IonSegmentButton
                                    value={2}
                                    onClick={() => {
                                        this.setState({
                                            segmentActive: 2
                                        });
                                    }}
                                >
                                    <IonLabel>Caja Chica</IonLabel>
                                </IonSegmentButton>
                            </IonSegment>
                        </IonCol>
                        {
                            segmentActive == 1 ?
                                <>
                                    <IonCol col-5 size='5' style={{ textAlign: "center" }}>
                                        <IonButton
                                            expand="full"
                                            onClick={(e: any) => {
                                                e.persist();
                                                this.setState({
                                                    isOpenDateStart: true,
                                                });
                                            }}
                                        >
                                            Inicio :
                                            <Moment
                                                date={DateStart}
                                                format="DD-MM-YYYY"
                                            />
                                        </IonButton>
                                        <IonPopover
                                            isOpen={isOpenDateStart}
                                            onDidDismiss={() =>
                                                this.setState({
                                                    isOpenDateStart: false,
                                                })}
                                        >
                                            <IonDatetime
                                                presentation="date"
                                                value={moment(DateStart, "YYYY-MM-DD hh:mm").format("YYYY-MM-DD")}
                                                onIonChange={(e: any) => {
                                                    this.setState({ DateStart: e.detail.value, isOpenDateEnd: false });
                                                    setTimeout(this.refreshminireport.bind(this), 100);
                                                }}
                                            ></IonDatetime>
                                        </IonPopover>
                                    </IonCol>
                                    <IonCol col-2 size='2' style={{ textAlign: "center" }}>
                                        <IonButton color='primary' expand="full" onClick={(e: any) => {
                                            e.persist();
                                            this.setState({ isOpenModalFilterDate: true });
                                        }}>
                                            <IonIcon icon={funnel}></IonIcon>
                                        </IonButton>
                                        <IonPopover
                                            isOpen={isOpenModalFilterDate}
                                            onDidDismiss={() =>
                                                this.setState({ isOpenModalFilterDate: false })}
                                        >
                                            <IonList inset={true}>
                                                <IonItem
                                                    onClick={(e: any) => this.changeFilterDate({ target: { name: 'get_date', value: 'hoy' } })}
                                                >
                                                    <IonLabel>Hoy</IonLabel>
                                                </IonItem>
                                                <IonItem
                                                    onClick={(e: any) => this.changeFilterDate({ target: { name: 'get_date', value: 'ayer' } })}>
                                                    <IonLabel>Ayer</IonLabel>
                                                </IonItem>
                                                <IonItem
                                                    onClick={(e: any) => this.changeFilterDate({ target: { name: 'get_date', value: 'ultimo_7' } })}>
                                                    <IonLabel>Los Ultimos 7 Dias</IonLabel>
                                                </IonItem>
                                                <IonItem
                                                    onClick={(e: any) => this.changeFilterDate({ target: { name: 'get_date', value: 'este_mes' } })}>
                                                    <IonLabel>Este Mes</IonLabel>
                                                </IonItem>
                                                <IonItem
                                                    onClick={(e: any) => this.changeFilterDate({ target: { name: 'get_date', value: 'este_ano' } })}>
                                                    <IonLabel>Este Año</IonLabel>
                                                </IonItem>
                                                <IonItem
                                                    onClick={(e: any) => this.changeFilterDate({ target: { name: 'get_date', value: 'ano_pasado' } })}>
                                                    <IonLabel>El Año Pasado</IonLabel>
                                                </IonItem>
                                            </IonList>
                                        </IonPopover>
                                    </IonCol>
                                    <IonCol col-5 size='5' style={{ textAlign: "center" }}>
                                        <IonButton
                                            expand="full"
                                            onClick={(e: any) => {
                                                e.persist();
                                                this.setState({ isOpenDateEnd: true });
                                            }}
                                        >
                                            Fin :
                                            <Moment
                                                date={DateEnd}
                                                format="DD-MM-YYYY"
                                            />
                                        </IonButton>
                                        <IonPopover
                                            isOpen={isOpenDateEnd}
                                            onDidDismiss={() =>
                                                this.setState({ isOpenDateEnd: false })}
                                        >
                                            <IonDatetime
                                                presentation="date"
                                                value={moment(DateEnd, "YYYY-MM-DD hh:mm").format("YYYY-MM-DD")}
                                                onIonChange={(e: any) => {
                                                    this.setState({ DateEnd: e.detail.value, isOpenDateEnd: false });
                                                    setTimeout(this.refreshminireport.bind(this), 100);
                                                }}

                                            ></IonDatetime>
                                        </IonPopover>
                                    </IonCol>

                                    <IonCol col-6 size='6'>
                                        <Link style={{ textDecoration: 'none', color: "#ffffff" }} to={"/dashboard_pos/orders"}>
                                            <IonCard>
                                                <IonCardHeader>
                                                    <IonCardTitle style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                        <label style={{ fontSize: "15px" }}>Total Ventas</label>
                                                        <IonIcon icon={cashOutline} color="success" />
                                                    </IonCardTitle>
                                                </IonCardHeader>
                                                <IonCardContent>
                                                    <h2> <strong>{minirepoort.total_sales ? _numberFormat.format(minirepoort.total_sales).replace("$", currencyprimary) : _numberFormat.format(0).replace("$", currencyprimary)}</strong> </h2>
                                                </IonCardContent>
                                            </IonCard>
                                        </Link>
                                    </IonCol>
                                    <IonCol col-6 size='6'>
                                        <Link style={{ textDecoration: 'none', color: "#ffffff" }} to={"/dashboard_pos/orders"}>
                                            <IonCard>
                                                <IonCardHeader>
                                                    <IonCardTitle style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                        <label style={{ fontSize: "15px" }}>Cotizaciones</label>
                                                        <IonIcon icon={cashOutline} color="success" />
                                                    </IonCardTitle>
                                                </IonCardHeader>
                                                <IonCardContent>
                                                    <h2> <strong>{minirepoort.total_quotations ? minirepoort.total_quotations : 0}</strong></h2>
                                                </IonCardContent>
                                            </IonCard>
                                        </Link>
                                    </IonCol>
                                    <IonCol col-6 size='6'>
                                        <Link style={{ textDecoration: 'none', color: "#ffffff" }} to={"/dashboard_pos/orders"}>

                                            <IonCard>
                                                <IonCardHeader>
                                                    <IonCardTitle style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                        <label style={{ fontSize: "15px" }}>Pre-Venta</label>
                                                        <IonIcon icon={cashOutline} color="success" />
                                                    </IonCardTitle>
                                                </IonCardHeader>
                                                <IonCardContent>
                                                    <h2><strong>{minirepoort.total_sales ? minirepoort.total_pre_sales : 0}</strong></h2>
                                                </IonCardContent>
                                            </IonCard>
                                        </Link>
                                    </IonCol>
                                    <IonCol col-6 size='6'>
                                        <Link style={{ textDecoration: 'none', color: "#ffffff" }} to={"/dashboard_pos/orders"}>
                                            <IonCard>
                                                <IonCardHeader>
                                                    <IonCardTitle style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                        <label style={{ fontSize: "15px" }}>Suspendidas</label>
                                                        <IonIcon icon={cashOutline} color="success" />
                                                    </IonCardTitle>
                                                </IonCardHeader>
                                                <IonCardContent>
                                                    <h2><strong>{minirepoort.total_suspended ? minirepoort.total_suspended : 0}</strong></h2>
                                                </IonCardContent>
                                            </IonCard>
                                        </Link>
                                    </IonCol>
                                </>
                                : null
                        }
                    </IonRow>
                    {
                        segmentActive == 2 ?
                            <>
                                {
                                    cash_register_util && cash_register_util.current_register ?
                                        <IonRow>
                                            <IonCol size='12' col-12 className='text-center'>
                                                <h5>CERRAR CAJA</h5>
                                            </IonCol>
                                            <IonCol col-6 size='6'>
                                                {(data_default && data_default.cash_register_util && data_default.cash_register_util.primarydata
                                                    && data_default.cash_register_util.primarydata.currency) ?? 'Cash'} <br />
                                                <input autoComplete="off" onFocus={this.handleFocus} type="number" className='input_quantity style_input' value={fields_register.open_amount ?? 0} min="0" />
                                            </IonCol>
                                            <IonCol col-6 size='6'>
                                                {(data_default && data_default.cash_register_util && data_default.cash_register_util.secondarydata
                                                    && data_default.cash_register_util.secondarydata.name) ?? 'Secundaria'} <br />
                                                <input autoComplete="off" onFocus={this.handleFocus} type="number" className='input_quantity style_input' value={fields_register.open_amount_secondary ?? 0} min="0" />
                                            </IonCol>
                                            <IonCol size='12' col-12 className='text-center'>
                                                <IonButton color="danger" onClick={e => this.SaveRegister()}>
                                                    Cerrar Caja
                                                </IonButton>

                                            </IonCol>
                                            <IonCol size='12' col-12 className='text-center'>
                                                <h5>Denominaciones en  {(data_default && data_default.cash_register_util && data_default.cash_register_util.primarydata
                                                    && data_default.cash_register_util.primarydata.currency) ?? 'Cash'} {_numberFormat.format(fields_register.open_amount ?? 0).replace("$", "")}</h5>
                                            </IonCol>

                                            <IonCol col-4 size='4' className='text-center'>
                                                Denominación
                                            </IonCol>
                                            <IonCol col-4 size='4' className='text-center'>
                                                Contar
                                            </IonCol>
                                            <IonCol col-4 size='4' className='text-center'>
                                                Subtotal
                                            </IonCol>
                                            {
                                                array_cash_denominations && array_cash_denominations.map((val: any, key: any) =>
                                                    <>
                                                        <IonCol col-4 size='4' className='text-center'>
                                                            {val.key} X
                                                        </IonCol>

                                                        <IonCol col-4 size='4' className='text-center'>
                                                            <input autoComplete="off" onFocus={this.handleFocus} type="number" className='input_quantity style_input'
                                                                value={val.quantity ?? 0} min="0"
                                                                onChange={(e: any) => this.handleChangeArrayDenomitations(key, { target: { name: val.key, value: e.target.value, type: 'cash' } })}
                                                            />
                                                        </IonCol>

                                                        <IonCol col-4 size='4' className='text-center'>
                                                            = {_numberFormat.format(val.quantity * val.key).replace("$", "")}
                                                        </IonCol>
                                                    </>
                                                )
                                            }
                                            <IonCol size='12' col-12 className='text-center'>
                                                <h5>Denominaciones en    {(data_default && data_default.cash_register_util && data_default.cash_register_util.secondarydata
                                                    && data_default.cash_register_util.secondarydata.name) ?? 'Secundaria'} {_numberFormat.format(fields_register.open_amount_secondary ?? 0).replace("$", "")}</h5>
                                            </IonCol>

                                            <IonCol col-4 size='4' className='text-center'>
                                                Denominación
                                            </IonCol>
                                            <IonCol col-4 size='4' className='text-center'>
                                                Contar
                                            </IonCol>
                                            <IonCol col-4 size='4' className='text-center'>
                                                Subtotal
                                            </IonCol>
                                            {
                                                array_cash_secondary && array_cash_secondary.map((val: any, key: any) =>
                                                    <>
                                                        <IonCol col-4 size='4' className='text-center'>
                                                            {val.key} X
                                                        </IonCol>

                                                        <IonCol col-4 size='4' className='text-center'>
                                                            <input autoComplete="off" onFocus={this.handleFocus} type="number" className='input_quantity style_input'
                                                                value={val.quantity ?? 0} min="0"
                                                                onChange={(e: any) => this.handleChangeArrayDenomitations(key, { target: { name: val.key, value: e.target.value, type: 'secondary' } })}
                                                            />
                                                        </IonCol>

                                                        <IonCol col-4 size='4' className='text-center'>
                                                            = {_numberFormat.format(val.quantity * val.key).replace("$", "")}
                                                        </IonCol>
                                                    </>
                                                )
                                            }
                                            <IonCol size='12' col-12 className='text-center'>
                                                <IonButton color="danger" onClick={e => this.SaveRegister()}>
                                                    Cerrar Caja
                                                </IonButton>

                                            </IonCol>


                                        </IonRow>

                                        :
                                        <IonRow>
                                            <IonCol size='12' col-12 className='text-center'>
                                                <h5>ABRIR CAJA</h5>
                                            </IonCol>
                                            <IonCol size='12' col-12>
                                                {
                                                    data_default && data_default.businessLocations && data_default.businessLocations.length > 0 ?
                                                        <Select
                                                            onChange={(e: any) => this.handleChangeRegister({ target: { name: 'location_id', value: e.value } })}
                                                            placeholder="Ubicación Comercial"
                                                            name='location_id'
                                                            menuPortalTarget={document.querySelector('body')}
                                                            isSearchable={false}
                                                            options={
                                                                data_default.businessLocations && data_default.businessLocations.map((option: any) => (
                                                                    { label: option.name, value: option.id }
                                                                ))
                                                            }
                                                            styles={{
                                                                menu: provided => ({ ...provided, zIndex: 9999, color: 'black' }),
                                                            }}
                                                            defaultValue={fields_register.location_id ?
                                                                data_default.businessLocations && data_default.businessLocations.length > 0 ?
                                                                    { label: data_default.businessLocations.filter((item: any) => item.id == fields_register.location_id)[0].name, value: data_default.businessLocations.filter((item: any) => item.id == fields_register.location_id)[0].id }
                                                                    : null
                                                                : null
                                                            }
                                                        /> : null
                                                }
                                                {formErrors && formErrors.location_id && (
                                                    <IonText color="danger" className="ion-padding-start">
                                                        <small>{formErrors.location_id}</small>
                                                    </IonText>
                                                )}
                                            </IonCol>
                                            <IonCol col-6 size='6'>
                                                {(data_default && data_default.cash_register_util && data_default.cash_register_util.primarydata
                                                    && data_default.cash_register_util.primarydata.currency) ?? 'Cash'} <br />
                                                <input autoComplete="off" onFocus={this.handleFocus} type="number" className='input_quantity style_input' value={fields_register.open_amount ?? 0} min="0" />
                                            </IonCol>
                                            <IonCol col-6 size='6'>
                                                {(data_default && data_default.cash_register_util && data_default.cash_register_util.secondarydata
                                                    && data_default.cash_register_util.secondarydata.name) ?? 'Secundaria'}  <br />
                                                <input autoComplete="off" onFocus={this.handleFocus} type="number" className='input_quantity style_input' value={fields_register.open_amount_secondary ?? 0} min="0" />
                                            </IonCol>
                                            <IonCol col-6 size='6'>
                                                Tasa de Cambio <br />
                                                <input autoComplete="off" onFocus={this.handleFocus} type="number" className='input_quantity style_input'
                                                    value={fields_register.tasa_cambio ?? 0} min="0"
                                                    onChange={(e: any) => this.handleChangeRegister({ target: { name: 'tasa_cambio', value: e.target.value } })} />
                                                {formErrors && formErrors.tasa_cambio && (
                                                    <IonText color="danger" className="ion-padding-start">
                                                        <small>{formErrors.tasa_cambio}</small>
                                                    </IonText>
                                                )}
                                            </IonCol>
                                            <IonCol size='12' col-12 className='text-center'>
                                                <IonButton color="success" onClick={e => this.SaveRegister()}>
                                                    Abrir  Caja
                                                </IonButton>
                                            </IonCol>
                                            <IonCol size='12' col-12 className='text-center'>
                                                <h5>Denominaciones en  {(data_default && data_default.cash_register_util && data_default.cash_register_util.primarydata
                                                    && data_default.cash_register_util.primarydata.currency) ?? 'Cash'} {_numberFormat.format(fields_register.open_amount ?? 0).replace("$", "")}</h5>
                                            </IonCol>

                                            <IonCol col-4 size='4' className='text-center'>
                                                Denominación
                                            </IonCol>
                                            <IonCol col-4 size='4' className='text-center'>
                                                Contar
                                            </IonCol>
                                            <IonCol col-4 size='4' className='text-center'>
                                                Subtotal
                                            </IonCol>
                                            {
                                                array_cash_denominations && array_cash_denominations.map((val: any, key: any) =>
                                                    <>
                                                        <IonCol col-4 size='4' className='text-center'>
                                                            {val.key} X
                                                        </IonCol>

                                                        <IonCol col-4 size='4' className='text-center'>
                                                            <input autoComplete="off" onFocus={this.handleFocus} type="number" className='input_quantity style_input'
                                                                value={val.quantity ?? 0} min="0"
                                                                onChange={(e: any) => this.handleChangeArrayDenomitations(key, { target: { name: val.key, value: e.target.value, type: 'cash' } })}
                                                            />
                                                        </IonCol>

                                                        <IonCol col-4 size='4' className='text-center'>
                                                            = {_numberFormat.format(val.quantity * val.key).replace("$", "")}
                                                        </IonCol>
                                                    </>
                                                )
                                            }
                                            <IonCol size='12' col-12 className='text-center'>
                                                <h5>Denominaciones en    {(data_default && data_default.cash_register_util && data_default.cash_register_util.secondarydata
                                                    && data_default.cash_register_util.secondarydata.name) ?? 'Secundaria'} {_numberFormat.format(fields_register.open_amount_secondary ?? 0).replace("$", "")}</h5>
                                            </IonCol>

                                            <IonCol col-4 size='4' className='text-center'>
                                                Denominación
                                            </IonCol>
                                            <IonCol col-4 size='4' className='text-center'>
                                                Contar
                                            </IonCol>
                                            <IonCol col-4 size='4' className='text-center'>
                                                Subtotal
                                            </IonCol>
                                            {
                                                array_cash_secondary && array_cash_secondary.map((val: any, key: any) =>
                                                    <>
                                                        <IonCol col-4 size='4' className='text-center'>
                                                            {val.key} X
                                                        </IonCol>

                                                        <IonCol col-4 size='4' className='text-center'>
                                                            <input autoComplete="off" onFocus={this.handleFocus} type="number" className='input_quantity style_input'
                                                                value={val.quantity ?? 0} min="0"
                                                                onChange={(e: any) => this.handleChangeArrayDenomitations(key, { target: { name: val.key, value: e.target.value, type: 'secondary' } })}
                                                            />
                                                        </IonCol>

                                                        <IonCol col-4 size='4' className='text-center'>
                                                            = {_numberFormat.format(val.quantity * val.key).replace("$", "")}
                                                        </IonCol>
                                                    </>
                                                )
                                            }
                                            <IonCol size='12' col-12 className='text-center'>
                                                <IonButton color="success" onClick={e => this.SaveRegister()}>
                                                    Abrir  Caja
                                                </IonButton>
                                            </IonCol>
                                        </IonRow>
                                }
                            </>
                            : null
                    }

                </IonContent>
            </IonPage >
        );
    };
}

const mapStateToProps = (state: any) => {
    return {
        data: state.data,
        post_: PropTypes.func.isRequired,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        post_: (data: any, controller: string) => dispatch(UtilActions.post_(data, controller)),
        get_: (fields: any, controller: string) => dispatch(PosActions.get_(fields, controller)),

    }
};

export default connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(Home);

